module.exports = __webpack_public_path__ + "static/media/colorPicker.3df65365.jpg";